import { Button } from '../Button';
import { Col } from '../Col';
import { appConfig } from '../config';
import { Div } from '../HTMLElement';
import { t } from '../i18n/i18n';
import { Link } from '../router/Link';
import { Row } from '../Row';
import { PasswordInput, TextInput } from './fields/Input';
import { FormGroup } from './FormGroup';
import { LoginFormHelper, LoginFormProps } from './LoginForm';

export const LoginFormA = ({ ...otherProps }: LoginFormProps) => (
  <LoginFormHelper {...otherProps}>
    {({ closeModal, fieldsHelper, forgotPasswordPagePath }) => (
      <>
        <Div marginBottom={4}>
          <FormGroup {...fieldsHelper.username.formGroup} label={fieldsHelper.username.formGroup.label}>
            <TextInput
              {...fieldsHelper.username.textInput}
              placeholder={
                appConfig.form?.showPlaceholder ? t('form.loginForm.fields.username.placeholder') : undefined
              }
            />
          </FormGroup>
          <FormGroup {...fieldsHelper.password.formGroup} label={fieldsHelper.password.formGroup.label}>
            <PasswordInput
              {...fieldsHelper.password.passwordInput}
              placeholder={
                appConfig.form?.showPlaceholder ? t('form.loginForm.fields.password.placeholder') : undefined
              }
            />
          </FormGroup>
        </Div>
        {appConfig.form?.explainMandatoryFields && (
          <Div className="mandatory-fields extra-small">{t('accessibility.mandatory')}</Div>
        )}
        {fieldsHelper.buttons.cancel ? (
          <Row>
            <Col size={6}>
              <Div display="grid">
                <Button className="cancel-button" {...fieldsHelper.buttons.cancel} variant="outline-primary" />
              </Div>
            </Col>
            <Col size={6}>
              <Div display="grid">
                <Button className="cancel-submit-button" {...fieldsHelper.buttons.submit} />
              </Div>
            </Col>
          </Row>
        ) : (
          <Div display="grid">
            <Button className="submit-button" {...fieldsHelper.buttons.submit} />
          </Div>
        )}
        <Div marginTop={3}>
          <Link
            className="forgot-pass text-muted text-secondary fw-light small"
            onClick={closeModal}
            to={forgotPasswordPagePath}
          >
            {t('account.passwordForgotten')}
          </Link>
        </Div>
      </>
    )}
  </LoginFormHelper>
);
